import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import { RouterLink } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from 'src/modules/directives/module';
import { RetiredUserDashboard } from './components/dashboard/component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    RouterLink
  ],
  declarations: [RetiredUserDashboard],
  exports: [RetiredUserDashboard],
})
export class RetiredUsersAdminModule {}
